import { z } from 'zod';
import { SenseType } from '../types/enums.js';
const senseTypeSchema = z.union([
    z.literal(SenseType.TempSense),
    z.literal(SenseType.HumiditySense),
    z.literal(SenseType.ShockSense),
    z.literal('tempSense'),
    z.literal('humiditySense'),
    z.literal('shockSense')
]);
const versionSchema = z
    .object({
    appVersion: z.string().optional(),
    apiVersion: z.string().optional(),
    firmwareVersion: z.string().optional(),
    firmwareApiVersion: z.string().optional()
})
    .optional();
const baseNativeSenseDataSchema = z.object({
    type: senseTypeSchema,
    uid: z.string(),
    configTime: z.number(),
    startTime: z.number(),
    startDelay: z.number(),
    elapsedTime: z.number(),
    runningTime: z.number().optional(),
    numberOfDatapointsAvailable: z.number(),
    numberOfDatapointsRead: z.number().optional(),
    interval: z.number(),
    statuses: z.array(z.string()),
    versionInfo: versionSchema,
    limits: z.record(z.unknown()),
    attainedValues: z.record(z.unknown()).optional(),
    batteryStatus: z.number().optional().nullable() // can be undefined
});
const nativeTempSenseDataSchema = baseNativeSenseDataSchema.extend({
    datapoints: z.object({
        temperature: z.array(z.number().nullable()).optional().nullable()
    }),
    limits: z.object({
        minTemperature: z.number().optional().nullable(),
        maxTemperature: z.number().optional().nullable()
    }),
    attainedValues: z
        .object({
        minTemperature: z.number().optional().nullable(),
        maxTemperature: z.number().optional().nullable()
    })
        .optional(),
    currentValues: z.object({
        temperature: z.number().optional().nullable()
    })
});
const nativeHumiditySenseDataSchema = baseNativeSenseDataSchema.extend({
    datapoints: z.object({
        temperature: z.array(z.number().nullable()).optional().nullable(),
        humidity: z.array(z.number().nullable()).optional().nullable()
    }),
    limits: z.object({
        minTemperature: z.number().optional().nullable(),
        maxTemperature: z.number().optional().nullable(),
        minHumidity: z.number().optional().nullable(),
        maxHumidity: z.number().optional().nullable()
    }),
    attainedValues: z
        .object({
        minTemperature: z.number().optional().nullable(),
        maxTemperature: z.number().optional().nullable(),
        minHumidity: z.number().optional().nullable(),
        maxHumidity: z.number().optional().nullable()
    })
        .optional(),
    currentValues: z.object({
        temperature: z.number().optional().nullable(),
        humidity: z.number().optional().nullable()
    })
});
const nativeSenseDataSchema = z.union([nativeTempSenseDataSchema, nativeHumiditySenseDataSchema]);
export { senseTypeSchema, nativeTempSenseDataSchema, nativeHumiditySenseDataSchema, nativeSenseDataSchema };
